import React, { useState, useEffect } from "react"

export default function SchedulePicker(props) {
    const [selected, setSelected] = useState(props.selected);
    const [value, setValue] = useState(props.default);

    // on change input number, update external state with input value. ALSO update local value
    const handleUpdateValue = (e) => {
        props.edit(e);
        setValue(e.target.value);
    }
    // on toggle off, set external state to deadline = null
    // on toggle on, set external state to local value
    const handleToggle = () => {
        let toggleOff = {target: {id: props.id, value: null}}
        let toggleOn = {target: {id: props.id, value: value}}
        selected ? props.edit(toggleOff) : props.edit(toggleOn);
        setSelected(!selected);
    }


    return (
        <>
            <div
                id="toggle-container"
                className={"toggle-container gap-right-xs" + (selected ? " active" : "")}
                role="checkbox"
                aria-checked={selected}
                tabIndex={props.tabIndex}
                onClick={() => handleToggle()}
                >
                <div id="toggle-button" className={selected ? "toggle-button active" : "toggle-button"}></div>
            </div>
            <p className={"iblock " + selected ? "light-black" : "light"}>{props.label}</p>
            <div className="flex-row">
            { selected && 
                <>
                    <input type="number" id={props.id} defaultValue={value} maxLength="1" min={props.min ? props.min : "1"} max={props.max ? props.max : "999"} onChange={(e) => handleUpdateValue(e) } />
                    <p className="content2 light-black">days from date the invoice was sent</p>
                </>
            }
            </div>
        </>
    )
}
